import { indexBy, prop, omit } from 'ramda';

import * as appointments from 'modules/appointments/actionTypes';
import * as interventionActionTypes from 'modules/interventions/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

const initialState = {};

const eventCleaner = event => ({
  ...omit(['links', 'createdBy'], event),
  ...(event?.createdBy ? { createdBy: event.createdBy.id } : {}),
});

const addOrUpdateEvents = (state, events) => ({
  ...state,
  ...indexBy(prop('id'))(
    events.filter(event => !!event).map(event => eventCleaner({ ...state?.[event.id], ...event }))
  ),
});

const afterGetCollection = (state, { payload }) => {
  const events = payload?.content?.flatMap(item => item.events) ?? [];
  return addOrUpdateEvents(state, events);
};

const afterGetAppointment = (state, { payload: appointment }) => {
  const events = [...(appointment?.events ?? []), ...(appointment?.intervention?.events ?? [])];
  return addOrUpdateEvents(state, events);
};

export default createReducer(initialState, {
  [appointments.FETCH_APPOINTMENTS_SUCCESS]: afterGetCollection,
  [appointments.FETCH_APPOINTMENT_SUCCESS]: afterGetAppointment,
  [appointments.FETCH_EVENTS_SUCCESS]: afterGetAppointment,
  [appointments.PUT_SUCCESS]: afterGetAppointment,
  [appointments.POST_SUCCESS]: afterGetAppointment,
  [appointments.PATCH_STATUS_SUCCESS]: afterGetAppointment,
  [interventionActionTypes.POST_SEND_BY_SUCCESS]: afterGetAppointment,
});
